import { GraphQLClient } from 'graphql-request';
import { useAuthContext } from '../../apps/auth/contexts/AuthContext';
import { globalConfig } from '../config/config';

const useGraphQLClient = () => {
	const graphQLClient = new GraphQLClient(globalConfig.get().APP_API_GRAPHQL_URL, { headers: {} });

	const authContext = useAuthContext();
	// Set a single header
	if (authContext.authAccessToken) {
		graphQLClient.setHeader('Authorization', `Bearer ${authContext.authAccessToken}`);
		if (authContext.authContext) {
			graphQLClient.setHeader('X-Authorization-Context-Type', `${authContext.authContext}`);
		}
		if (authContext.currentCompany) {
			graphQLClient.setHeader('X-Authorization-Context-CompanyId', `${authContext.currentCompany.id.toString()}`);
		}
		if (authContext.authOverrideUserId) {
			graphQLClient.setHeader(
				'X-Authorization-Context-ImpersonatedUserId',
				`${authContext.authOverrideUserId.toString()}`,
			);
		}
	}

	return graphQLClient;
};

export default useGraphQLClient;
